import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '../../../services/modal.service';
import { Subscription } from 'rxjs';
import { ModalArgs } from '../../../models/modal';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'lib-auto-payroll-skip-modal',
  templateUrl: './auto-payroll-skip-modal.component.html',
  standalone: false
})
export class AutoPayrollSkipModal implements OnInit {
  @ViewChild('confirmModalRef', { static: true }) public confirmModalRef: TemplateRef<any>;

  private sub: Subscription;
  @Input() public periodEndDate: Date;
  @Input() public payDate: Date;
  @Input() onSkip: Function;
  @Input() onCancel: Function;
  @Input() onSkipAndNavigate: Function;

  constructor(
    private modalService: ModalService,
    private ngbModalService: NgbModal
  ) {}

  ngOnInit() {}

  skip() {
    this.onSkip();
  }

  skipAndNavigate() {
    this.onSkipAndNavigate();
  }

  cancel() {
    this.onCancel();
  }
}
